/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coach_Suggestions_LabelInputs */

const en_us2_coach_suggestions_label = /** @type {(inputs: Coach_Suggestions_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Suggested questions`)
};

const pt_br2_coach_suggestions_label = /** @type {(inputs: Coach_Suggestions_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sugestões de pergunta`)
};

const es_419_coach_suggestions_label = /** @type {(inputs: Coach_Suggestions_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Preguntas sugeridas`)
};

const pt_pt2_coach_suggestions_label = /** @type {(inputs: Coach_Suggestions_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sugestões de perguntas`)
};

const fr_fr2_coach_suggestions_label = /** @type {(inputs: Coach_Suggestions_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Questions suggérées`)
};

const de_de2_coach_suggestions_label = /** @type {(inputs: Coach_Suggestions_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vorgeschlagene Fragen`)
};

const it_it2_coach_suggestions_label = /** @type {(inputs: Coach_Suggestions_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Domande suggerite`)
};

/**
* | output |
* | --- |
* | "Suggested questions" |
*
* @param {Coach_Suggestions_LabelInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const coach_suggestions_label = /** @type {((inputs?: Coach_Suggestions_LabelInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coach_Suggestions_LabelInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_coach_suggestions_label(inputs)
	if (locale === "es-419") return es_419_coach_suggestions_label(inputs)
	if (locale === "pt-PT") return pt_pt2_coach_suggestions_label(inputs)
	if (locale === "fr-FR") return fr_fr2_coach_suggestions_label(inputs)
	if (locale === "de-DE") return de_de2_coach_suggestions_label(inputs)
	if (locale === "it-IT") return it_it2_coach_suggestions_label(inputs)
	return en_us2_coach_suggestions_label(inputs)
});
export { coach_suggestions_label as "coach.suggestions_label" }